import { Pipe, PipeTransform, inject } from '@angular/core';
import { Store } from '@ngxs/store';
import { AccountState } from '@shared/states/account.state';
import { brandedText } from '@shared/utilities/branding.utilities';

@Pipe({
  name: 'brandify',
  standalone: false,
})
export class Brandify implements PipeTransform {
  private store = inject(Store);

  public transform(text: string): string {
    const branding = this.store.selectSnapshot(AccountState.parentBranding);
    return brandedText(text || '', branding);
  }
}
